import { Body1, Body2, H4, Subtitle2 } from "melodies-source/Text";
import styled from "styled-components";
import { PlaceDetail } from "Components/Maps";
import { CalendarDisplay } from "Components/CalendarDisplay";

interface ConcertCardProps {
  concert: PlaceDetail;
  isNew?: boolean;
  isSelected?: boolean;
  disableTruncate?: boolean;
}

export const ConcertCard = ({
  concert,
  isNew,
  isSelected,
  disableTruncate,
}: ConcertCardProps) => {
  return (
    <Container style={{ opacity: isNew && isSelected ? 1 : 0.7 }}>
      <CalendarDisplay date={concert.date} />
      <Content>
        <H4 style={!disableTruncate ? truncate : undefined}>{concert.title}</H4>
        <Body2 style={!disableTruncate ? truncate : undefined}>
          {concert.address} • {concert.date.toFormat("h:mm a (ZZZZ)")}
        </Body2>
      </Content>
      <div style={{ alignSelf: "flex-start" }}>
        {isNew && (
          <New>
            <Subtitle2>NEW</Subtitle2>
          </New>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  background: #f2f5f7;
  border-radius: 10px;
  padding: 10px;
  gap: 14px;
  flex: 1;
  min-width: 0;
`;

const Content = styled.div`
  min-width: 0;
  flex: 1;

  ${H4} {
    font-family: "Poppins";
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    color: #333;
  }
  ${Body1} {
    font-family: "Poppins";
    font-size: 14px;
    line-height: 20px;
  }
  ${Body1}, ${Body2} {
    color: #666;
  }
`;

const New = styled.div`
  background: #1b0076;
  border-radius: 9999px;
  padding: 0 10px;
  ${Subtitle2} {
    color: white;
  }
`;

const truncate: React.CSSProperties = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "100%",
};
